const { Button } = wp.components;

export const MediaUploaderGeneric = ({
  photo,
  buttonPosition,
  isContain = false,
  updateImage = (f) => f,
}) => {
  const position = buttonPosition ? buttonPosition : "left";
  const openMediaUploader = () => {
    if (!photo || !photo.mediaId) {
      // If no image is selected, open the media uploader
      const mediaUploader = wp.media({
        frame: "select",
        multiple: false,
      });

      mediaUploader.on("select", () => {
        const media = mediaUploader.state().get("selection").first().toJSON();
        console.log("media", media);

        updateImage({
          mediaId: media.id,
          mediaUrl: media.url,
          mediaWidth: media.width,
          mediaHeight: media.height,
          mediaSizes: media.sizes,
        });
      });

      mediaUploader.open();
    }
  };

  const removeMedia = () => {
    // Remove the selected image
    updateImage({
      mediaId: 0,
      mediaUrl: "",
      mediaWidth: 0,
      mediaHeight: 0,
      mediaSizes: {},
    });
  };

  const buttonStyle =
    position === "right"
      ? {
        position: "absolute",
        top: "10px",
        right: "10px",
        width: "fit-content",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        zIndex: 1,
      }
      : {
        position: "absolute",
        top: "10px",
        left: "10px",
        width: "fit-content",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        zIndex: 1,
      };

  const backgroundImg =
    photo && photo.hasOwnProperty("mediaUrl") && photo.mediaUrl.length > 0
      ? `url(${photo.mediaUrl})`
      : "";
  const backgroundSize = isContain ? "contain" : "cover";
  return (
    <div
      className="rbt-inline-image"
      style={{
        backgroundImage: backgroundImg,
        backgroundSize: backgroundSize,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "clamp(300px, 100%, 100px)",
        height: "clamp(300px, 100%, 100px)",
        aspectRatio: "1/1",
      }}
    >
      {photo &&
        photo.hasOwnProperty("mediaUrl") &&
        photo.mediaUrl.length > 0 ? (
        <div style={{ display: "block", position: "relative" }}>
          <div style={buttonStyle}>
            {/* <Button className="button-primary" onClick={openMediaUploader}>Change Image</Button> */}
            <Button className="button-secondary" onClick={removeMedia}>
              Remove Image
            </Button>
          </div>
        </div>
      ) : (
        <Button
          style={buttonStyle}
          className="button-primary"
          onClick={openMediaUploader}
        >
          Choose an Image
        </Button>
      )}
    </div>
  );
};
